'use strict';

var React = require('react');
var Link = require('react-router').Link;

module.exports = function TeaserLink(props) {
	
	const model = props.model;

	if(!model) {
		return	(
			<span>{props.children}</span>
		);
	}

	const programId = ((((model.relationships || {}).program || {}).data || {}).id || 'uncategorized');
	const articleId = ((((model.relationships || {}).article || {}).data || {}).id || false);

	// TODO: Is this a correct way to do this? Couldnt there be an article ID outside of our app? And what about linking to program cards?
	if(articleId) {
		var url = '/' + programId + '/' + articleId;
		return(
			<Link to={url} {...props}>
				{props.children}
			</Link>
		);
	}

	if(model.targetUrl) {
		return(
			<a href={model.targetUrl} {...props}>
				{props.children}
			</a>
		);
	}

	return(
		<a href="#" {...props}>
			{props.children}
		</a>
	);
};



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/TeaserLink.jsx
 **/